import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

const initialState = {
  authenticatedUser: null,
}

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setAuthenticatedUser(state, action) {
      state.authenticatedUser = action.payload
    },
  },
  extraReducers: (builder) => {
    /* Action which gets triggered
       when running persistor.purge() */
    builder.addCase(PURGE, () => {
      return initialState
    })
  },
})

export const { setAuthenticatedUser } = loginSlice.actions

export default loginSlice.reducer
